import { useEffect, useState } from "react";
import CustomLoader from "../../../../Components/custom/CustomLoader";
import DataTable from "react-data-table-component";
import { BsTrash } from "react-icons/bs";
import api from "../../../../api/axiosInstance";
const SubAccounts = (props) => {
  const [subAccounts, setSubAccounts] = useState([]);
  const [pending, setPending] = useState(true);
  const columns = [
    {
      name: "Id",
      selector: (row) => row.id,
      width: "80px",
    },
    {
      name: "Account Name",
      selector: (row) => row.accountName,
      width: "280px",
    },
    {
      name: "Operator",
      selector: (row) => row.operatorName,
    },

    // {
    //   name: "Options",
    //   show: true,
    //   selector: (row) => (
    //     <>
    //       <button
    //         className="btn btn-sm btn-danger btn-icon"
    //         onClick={() => deleteSubAccount(row)}
    //       >
    //         <BsTrash />
    //       </button>
    //     </>
    //   ),
    //   width: "180px",
    // },
  ];

  const editSubAccount = () => {};
  const deleteSubAccount = (canvasApiAccount) => {
    var canvasAccounts = [];
    canvasAccounts.push(canvasApiAccount);
    var config = {
      method: "patch",
      url: process.env.REACT_APP_API_URL + "SubAccounts/DeleteCanvasAccount",
      headers: {
        "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
      data: canvasAccounts,
    };

    api(config).then(function (response) {
      if (response.status == 200) {
        getSubAccounts();
      }
    });
  };
  const getSubAccounts = () => {
    var config = {
      method: "get",
      url: process.env.REACT_APP_API_URL + "SubAccounts/GetCanvasSubAccounts",
      headers: {
        "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
    };

    api(config).then(function (response) {
      setPending(false);
      if (response.status == 200) {
        console.log(response.data);
        setSubAccounts(response.data);
      }
    });
  };

  useEffect(() => {
    getSubAccounts();
  }, []);
  return (
    <>
      <div className="container-fluid mt-30">
        <div className="row">
          <div className="col-md-12 mb-15">
            <div className="card">
              <div className="card-header">
                <h3 className="card-title">Schools</h3>
                <div className="align-self-center"></div>
              </div>
              <div className="card-body p-0">
                <DataTable
                  columns={columns}
                  data={subAccounts}
                  className="table table-stripped"
                  pagination={true}
                  paginationPerPage={100}
                  paginationRowsPerPageOptions={[100, 200, 300, 500]}
                  progressPending={pending}
                  progressComponent={<CustomLoader />}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SubAccounts;
